import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {NavService} from '../../services/nav.service';
import {ResourcesService} from './service/resources.service';
import {ResourceModel} from './models/resources.model';
import {Platform} from '@ionic/angular';
import {AnalyticsService} from '../../services/analytics.service';
import {UserService} from '../../services/user.service';

@Component({
    selector: 'app-resources-page',
    templateUrl: './resources.page.html',
    styleUrls: ['./resources.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})
export class ResourcesPage implements OnInit {

    public resourceList: ResourceModel[] = null;
    public resourceListValid = false;
    public resourceListPromise: Promise<ResourceModel[]> = null;

    constructor(
        private router: Router,
        private nav: NavService,
        private platform: Platform,
        private linkSystem: NavService,
        private analytics: AnalyticsService,
        private resourceService: ResourcesService,
        public userService: UserService
    ) {
    }

    ngOnInit() {
    }

    ionViewWillEnter() {
        if (this.resourceList === null || !this.resourceListValid) {
            this.resourceListPromise = this.resourceService.getResourceList();
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('My Resources');

        if (this.resourceList === null || !this.resourceListValid) {
            this.resourceListPromise.then(data => {
                this.resourceList = data;
                this.resourceListValid = true;
            });
        }
    }

    openResource(item: ResourceModel) {
        this.analytics.trackEvent('resource_view', {
            resource_id: item.resource_id.toString(),
            resource_table: item.resource_table,
            resource_title: item.title,
            resource_folder: item.folder,
            resource_type: item.type,
            resource_url: item.link_universal,
        });

        this.platform.ready().then((platform) => {
            this.linkSystem.toLink(item.link_universal);
        });
    }

    updateStatus(item: ResourceModel) {
        this.resourceService.updateResourceStatus(item);
    }
}
